export const medicoAgenda = [
  {
    medico: 'Dr Fabio',
    codigo: 5,
  },
  {
    medico: 'Dr Luiz',
    codigo: 4860,
  },
  {
    medico: 'Dr Raphael',
    codigo: 3794,
  },
  {
    medico: 'Dr Valdyr',
    codigo: 24,
  },
  {
    medico: 'Dr Alexandre',
    codigo: 958,
  },
  {
    medico: 'Drª Cassia',
    codigo: 957,
  },
  {
    medico: 'Drª Fernanda',
    codigo: 2030,
  },
  {
    medico: 'Dr João',
    codigo: 2796,
  },
  {
    medico: 'Drª Marina',
    codigo: 2657,
  },
  {
    medico: 'Dr Roberto',
    codigo: 1628,
  },
  {
    medico: 'MG',
    codigo: 2921,
  },
  {
    medico: 'B/Ana',
    codigo: 1981,
  },
  {
    medico: 'EcgExt',
    codigo: 3804,
  },
  {
    medico: 'EcoInt',
    codigo: 3072,
  },
  {
    medico: 'Estudo',
    codigo: 4233,
  },
  /*  {
    medico: 'Dr Guilherme',
    codigo: 1343,
  }, */
  {
    medico: 'Dr Igor',
    codigo: 3283,
  },
];

export const medicoCPFs = [
  { cpf: '01534934880' },
  { cpf: '08396808805' },
  { cpf: '16384220873' },
  { cpf: '11016742886' },
  { cpf: '06798172806' },
  { cpf: '27003275864' },
  { cpf: '22356439811' },
  { cpf: '29538354826' },
  { cpf: '09339882733' },
  { cpf: '22776600860' },
  { cpf: '84398949704' },
  { cpf: '12215675780' },
  { cpf: '98765432100' },
  { cpf: '16188168880' },
  { cpf: '21964622840' },
  { cpf: '42394547863' },
  { cpf: '33256859860' },
];

export const medicoAgendaPac = [
  {
    medico: 'Dr Alexandre',
    codigo: 958,
  },
  {
    medico: 'Drª Cassia',
    codigo: 957,
  },
  {
    medico: 'Dr Fabio',
    codigo: 5,
  },
  {
    medico: 'Drª Fernanda',
    codigo: 2030,
  },
  {
    medico: 'Dr João',
    codigo: 2796,
  },
  {
    medico: 'Dr Luiz - Cardio Pediatra',
    codigo: 4860,
  },
  {
    medico: 'Drª Marina',
    codigo: 2657,
  },
  {
    medico: 'Dr Raphael',
    codigo: 3794,
  },
  {
    medico: 'Dr Roberto',
    codigo: 1628,
  },
  {
    medico: 'Dr Valdyr',
    codigo: 24,
  },
  {
    medico: 'Holter e Mapa',
    codigo: 2921,
  },
  /* {
    medico: 'Dr Guilherme',
    codigo: 1343,
  },
    {
    medico: 'Nutricionista Ana Carolina - Bioimpedancia',
    codigo: 1981,
  }, */
];